import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import axios from '../../axios/axiosconf';
import SuperadminLayout from './SuperadminLayout';
import './SuperadminStyles.css';

const DashboardSuperadmin = () => {
    const history = useHistory();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [verificandoVencimientos, setVerificandoVencimientos] = useState(false);
    const [alert, setAlert] = useState({ show: false, type: '', message: '' });

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }

        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        fetchDashboardData();
    }, [history]);

    const fetchDashboardData = async () => {
        try {
            const response = await axios.get('/superadmin/dashboard');
            setStats(response.data.stats);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('superadmin_token');
                localStorage.removeItem('superadmin_user');
                history.push('/superadmin/login');
            }
            setLoading(false);
        }
    };

    const handleVerificarVencimientos = async () => {
        if (!window.confirm('¿Desea verificar los vencimientos y actualizar automáticamente los clientes próximos a vencer?')) {
            return;
        }

        try {
            setVerificandoVencimientos(true);
            const response = await axios.post('/superadmin/clientes/verificar-vencimientos', {
                dias: 10 // Verificar clientes que vencen en los próximos 10 días
            });

            setAlert({
                show: true,
                type: 'success',
                message: response.data.message
            });

            // Recargar estadísticas
            fetchDashboardData();
        } catch (error) {
            console.error('Error verificando vencimientos:', error);
            setAlert({
                show: true,
                type: 'danger',
                message: error.response?.data?.message || 'Error al verificar vencimientos'
            });
        } finally {
            setVerificandoVencimientos(false);
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 5000);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    return (
        <SuperadminLayout>
            <h4 className="mb-4">Estadísticas del Sistema</h4>

            {/* Alertas */}
            {alert.show && (
                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                    {alert.message}
                    <button type="button" className="close" onClick={() => setAlert({ show: false, type: '', message: '' })}>
                        <span>&times;</span>
                    </button>
                </div>
            )}

            <div className="row">
                <div className="col-md-3">
                    <div className="stat-card primary">
                        <h3>{stats?.totalClientes || 0}</h3>
                        <p>Total Clientes</p>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="stat-card success">
                        <h3>{stats?.clientesActivos || 0}</h3>
                        <p>Clientes Activos</p>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="stat-card warning">
                        <h3>{stats?.totalUsuarios || 0}</h3>
                        <p>Total Usuarios</p>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="stat-card danger">
                        <h3>{stats?.promedioUsuarios || 0}</h3>
                        <p>Promedio Usuarios/Cliente</p>
                    </div>
                </div>
            </div>

            {stats?.clientesPorVencer > 0 && (
                <div className="alert alert-warning mt-4">
                    <i className="fas fa-exclamation-triangle"></i>{' '}
                    <strong>{stats.clientesPorVencer}</strong> cliente(s) próximos a vencer en los próximos 7 días
                </div>
            )}

            {stats?.clientesLimiteAlcanzado > 0 && (
                <div className="alert alert-danger mt-4">
                    <i className="fas fa-exclamation-circle"></i>{' '}
                    <strong>{stats.clientesLimiteAlcanzado}</strong> cliente(s) han alcanzado su límite de usuarios
                </div>
            )}

            <div className="mt-4">
                <h5>Acciones Rápidas</h5>
                <div className="row mt-3">
                    <div className="col-md-3">
                        <Link to="/superadmin/clientes/nuevo" className="btn btn-superadmin btn-block">
                            <i className="fas fa-plus"></i> Crear Cliente
                        </Link>
                    </div>
                    <div className="col-md-3">
                        <Link to="/superadmin/especialidades/nueva" className="btn btn-superadmin btn-block">
                            <i className="fas fa-plus"></i> Nueva Especialidad
                        </Link>
                    </div>
                    <div className="col-md-3">
                        <Link to="/superadmin/plantillas/nueva" className="btn btn-superadmin btn-block">
                            <i className="fas fa-plus"></i> Nueva Plantilla
                        </Link>
                    </div>
                    <div className="col-md-3">
                        <button
                            className="btn btn-warning btn-block"
                            onClick={handleVerificarVencimientos}
                            disabled={verificandoVencimientos}
                        >
                            {verificandoVencimientos ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    Verificando...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-calendar-check"></i> Verificar Vencimientos
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </SuperadminLayout>
    );
};

export default DashboardSuperadmin;
